import React from 'react';

export default function CloseCircleIcon({
  className = '',
  onClick,
  onKeyDown,
  tabIndex,
  role,
  'aria-label': ariaLabel,
  size = '20',
}) {
  return (
    <svg
      className={className}
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
      role={role}
      aria-label={ariaLabel}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.92984 17.0698C1.97473 16.1474 1.21291 15.0439 0.688821 13.8239C0.164731 12.6038 -0.111131 11.2916 -0.122669 9.96385C-0.134207 8.63605 0.11881 7.31926 0.621618 6.09029C1.12443 4.86133 1.86696 3.74481 2.80589 2.80589C3.74481 1.86696 4.86133 1.12443 6.09029 0.621618C7.31926 0.11881 8.63605 -0.134207 9.96385 -0.122669C11.2916 -0.111131 12.6038 0.164731 13.8239 0.688821C15.0439 1.21291 16.1474 1.97473 17.0698 2.92984C18.8914 4.81586 19.8994 7.34188 19.8766 9.96385C19.8538 12.5858 18.8021 15.0939 16.948 16.948C15.0939 18.8021 12.5858 19.8538 9.96385 19.8766C7.34188 19.8994 4.81586 18.8914 2.92984 17.0698ZM4.33984 15.6598C5.84096 17.161 7.87692 18.0043 9.99984 18.0043C12.1227 18.0043 14.1587 17.161 15.6598 15.6598C17.161 14.1587 18.0043 12.1227 18.0043 9.99984C18.0043 7.87692 17.161 5.84096 15.6598 4.33984C14.1587 2.83871 12.1227 1.99539 9.99984 1.99539C7.87692 1.99539 5.84096 2.83871 4.33984 4.33984C2.83871 5.84096 1.99539 7.87692 1.99539 9.99984C1.99539 12.1227 2.83871 14.1587 4.33984 15.6598ZM14.2398 7.16984L11.4098 9.99984L14.2398 12.8298L12.8298 14.2398L9.99984 11.4098L7.16984 14.2398L5.75984 12.8298L8.58984 9.99984L5.75984 7.16984L7.16984 5.75984L9.99984 8.58984L12.8298 5.75984L14.2398 7.16984Z"
        fill="currentColor"
      />
    </svg>
  );
}
